export const locales = ['en-US', 'fr-FR'];
export const defaultLocale = 'en-US';

export const localeNames = {
  'en-US': 'English',
  'fr-FR': 'Français',
};

export function getLocaleFromPathname(pathname) {
  const segments = pathname.split('/');
  const locale = segments[1];
  return locales.includes(locale) ? locale : defaultLocale;
}
